
import React, { useState, useRef, useEffect,useImperativeHandle, forwardRef } from 'react'

import { DescContent, Ctitle, DescIcon, IconClose } from './style'
// import { connect } from 'react-redux';
import { Modal } from 'antd-mobile'
import Delivery from './delivery';
import { Toast } from "antd-mobile";
import { getAddrInfo } from './../api'
import bridge from '@/config/JSbridge'
import bwmodel from '@/config/bwmodel';
import { handleUploadTrace } from '@/utils'
const Explain = ({top, token}, ref) => {
  
	const [descVisible, setDescVisible] = useState(false)
  const deliveryRef = useRef();
  const [visible, setVisible] = useState(false);
  const [addrInfo, setAddrInfo] = useState(null);

const isStorm = bwmodel.app === 'storm';
  function handleSubmitAddr(addr) {
    console.log(addr);
    setVisible(false);
    Toast.info('填写成功');
    setAddrInfo(addr);
  }

  console.log(ref);

  useImperativeHandle(ref, () => {
    return {
      show: () => {
        setDescVisible(true);
      }
    }
  })



  const handleLogin = () => {

		if(!isStorm) {
			window.location.href = "https://m.wogoo.com/app/download/wogoo_client/index.html"
		}
    bridge.callHandler(
      'nativeEvent',
      {
        event: 'login',
        params: {
          refreshOnBack: true
        }
      },
      () => {}
    );
  }

  useEffect(()=> {
    getAddrInfo({activityId: 130}).then(res => {
      if (res) {
        setAddrInfo(res)
      }
    })
  },[])
	return (
		<React.Fragment>
			<DescIcon
        style={{marginTop:top? top+'px':'60px'}}
				src={require('@/img/activity22/0.png')}
				onClick={() => {
          handleUploadTrace('Million_Rules_Click','click')
          setDescVisible(true)
        }}
        alt='市值风云'
      >
					活<br/>动<br/>规<br/>则
				</DescIcon>
			<Modal 
				visible={descVisible} 
				wrapClassName="rw-desc-modal-outer" className={'lx-desc-modal long-modal'} 
				transparent onClose={() => setDescVisible(false)}>
					<Ctitle>
						<div >活动规则</div>
					</Ctitle>
          <IconClose onClick={() => setDescVisible(false)} />
					<DescContent>
            

          <div className='content'>
          <h1>活动规则</h1>
          <div>一、参与<span style={{color:'#DF0000'}}>全民创作计划</span>（以下简称“本活动”）前，请您详细阅读活动规则。凡参与本活动，则视为您已阅读、理解并同意活动规则涉及到全部内容。</div>
          <div>活动名称</div>
          <div>社区优质创作者计划</div>
          <div>活动时间</div>
          <div>2025年01月01日起（每月一期）暂不设置停止日期，具体后续社区通知。</div>
          <div>奖励发放时间：次月10日前。</div>
          <div>投稿体裁：帖子、文章。</div>

          <h1>二、参与方式</h1>
          <div>1、活动期间，在市值风云平台创作，成功发布具有个股、指数、概念、板块等内容即视为参与优质创作者评选。</div>
          <div>2、带活动话题（如#每日复盘、#你问我答、#市值风云使用旅程）发布内容，分析真实的投资经验，成功发布即视为参与热门话题内容投稿。</div>

          <h1>三、参与要求</h1>
          <div>1、本活动鼓励、支持内容原创，参与活动的用户应采用原创内容投稿参与本活动，切保证在本次投稿前相关内容并未发布在本平台。
          如平台发现参与活动的内容为搬运、抄袭等非原创内容，平台有权进行相应处理，包括但不限于：删除、隐藏对应内容，取消该内容作者参与活动、评选获奖的资格，并进行处罚、公示。</div>
          <div>2、用户参与活动发布的内容，需遵守市值风云社区规范、本活动对投稿内容的相关要求。
          如平台发现用户通过不正当行为参与本活动，如恶意解读活动规则、恶意投稿与活动规则无关的内容、故意刷量、展示和诱导其他用户骗取点击互动等，以获取活动奖励，平台一经发现，有权采取措施，包括不限于：降低其活动奖励、撤销活动资格、限制提现、封禁账号等。</div>

          <h1>四、评选规则</h1>
          <div>优质创作奖</div>
          <div>根据社区排名生成优质创作分榜单（榜单交易日：12:00更新，发奖以此月官方公示名单为准），每月评选出<span style={{color:'#DF0000'}}>前20名</span>的优质创作者进行奖励）</div>
            
            <table style={{"width":"100%", textAlign:'center',}}>
              <tr><td>名次</td><td>奖励</td></tr>
              <tr><td>第1名</td><td>3000</td></tr>
              <tr><td>第2名</td><td>1500</td></tr>
              <tr><td>第3名</td><td>1000</td></tr>
              <tr><td>第4-10名</td><td>500</td></tr>
              <tr><td>第11-15名</td><td>200</td></tr>
              <tr><td>第16-20名</td><td>周边4选1</td></tr>
            </table>
            <div> 新周边：十八籽、涨停板。持续更新中。</div>
            <div> 周边地址填写入口：</div>
            <div className='addr' onClick={()=> {

              handleUploadTrace('Million_Harvest_Click', 'click')
              if(!token)  {
                return handleLogin();
                // return Toast.info('请先登录')
              }
    
              if (addrInfo) {
                
                deliveryRef.current.setParams(addrInfo);
              }
              setVisible(true);
            }}>填写收货地址</div>
            <div>1、影响排名的核心指标包括：</div>
            <div>● 当月发布的优质文章数、帖子数</div>
            <div>● 当月收获的点赞数、评论数、阅读数、粉丝数</div>
            <div>● 当月对其他用户的点赞数、评论数</div>
            <div>● 当月社区活跃度、内容原创性、社区行为规范等附加因素。</div>
            <div>2、活动结束后，市值风云社区官方将在数据盘点、风控排查后公布创作者排名（活动期间部分用户如存在不符合参与要求的行为，平台有权调整其排名）</div>
            <div>3、市值风云官方会根据创作者上述部分核心指标对其创作分进行增减分。</div>

            <div>热门内容奖</div>
            <div>1、用户可发布多个帖子、文章参与本话题活动。</div>
            <div>2、投稿内容需为有效内容：带活动标签、原创、内容与话题主题相关、10字以上（不含话题标签）、内容质量合格。</div>
            <div>3、在当月投稿的内容中，市值风云评审团将结合<span style={{color:'#DF0000'}}>主题相关性（50%）、内容质量（30%）、互动情况（20%）</span>等维度，次月结算日评选出优质内容并在社区进行公布后发布奖励。</div>
            <div>4、以下内容无法参与本活动：草稿、重复、审核未通过、被作者删除、不符合平台规范等内容。</div>

            </div>
          </DescContent>
          <Delivery visible={visible} ref={deliveryRef} onClose={() => setVisible(false)} onSubmit={handleSubmitAddr} activityId={130} />
		
			</Modal>
   </React.Fragment>
	)
}



export default React.memo(forwardRef(Explain));

// export default 


// WEBPACK FOOTER //
// ./src/views/activity_130/components/explain.js